module.exports = __webpack_public_path__ + "static/media/pins_warning.a787e027.png";